export default "__VITE_ASSET__a2e296Wv__"